import React, { useState } from 'react'
import styles from './ChangePasswordModal.module.scss'
import $apiJSON from 'http/apiJSON'

export default function ChangePasswordModal({ open, onClose, token }) {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState(null)
  const [showPassword, setShowPassword] = useState(false)

  if (!open) return null

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErrors(null)
    
    // Валидация на фронте
    if (!oldPassword) {
      setErrors('Введите текущий пароль')
      return
    }
    if (newPassword.length < 8) {
      setErrors('Новый пароль должен содержать минимум 8 символов')
      return
    }
    if (newPassword !== confirm) {
      setErrors('Пароли не совпадают')
      return
    }
    
    setLoading(true)
    try {
      const res = await $apiJSON.post('/change-password/', { 
        old_password: oldPassword, 
        new_password: newPassword 
      })
      window.dispatchEvent(new CustomEvent('notify', { 
        detail: { message: res.data.message || 'Пароль успешно изменен', type: 'success' } 
      }))
      // Сброс формы и закрытие
      setOldPassword('')
      setNewPassword('')
      setConfirm('')
      onClose()
    } catch (e) {
      if (e.response && e.response.status === 401) {
        window.dispatchEvent(new CustomEvent('sessionExpired'))
        return
      }
      // Отображаем ошибку с бэка
      if (e.response && e.response.data) {
        const errorData = e.response.data
        setErrors(errorData.error || errorData.detail || JSON.stringify(errorData))
      } else {
        setErrors('Сетевая ошибка. Попробуйте позже')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>Сменить пароль</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label>Текущий пароль</label>
            <div className={styles['auth-field']}>
              <input 
                type={showPassword ? 'text' : 'password'} 
                value={oldPassword} 
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Введите текущий пароль"
                autoComplete="current-password"
              />
              <button 
                type="button" 
                className={styles['password-toggle']} 
                onClick={() => setShowPassword(s => !s)}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>
          
          <div className={styles.field}>
            <label>Новый пароль</label>
            <div className={styles['auth-field']}>
              <input 
                type={showPassword ? 'text' : 'password'} 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Минимум 8 символов"
                autoComplete="new-password"
              />
            </div>
          </div>
          
          <div className={styles.field}>
            <label>Подтвердите новый пароль</label>
            <div className={styles['auth-field']}>
              <input 
                type={showPassword ? 'text' : 'password'} 
                value={confirm} 
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Повторите новый пароль"
                autoComplete="new-password"
              />
            </div>
          </div>
          
          {errors && (
            <div className={styles.errors}>
              {errors}
            </div>
          )}
          
          <div className={styles.actions}>
            <button className={styles.btn} onClick={onClose} type="button">
              Отмена
            </button>
            <button className={`${styles.btn} ${styles.btn_primary}`} type="submit" disabled={loading}>
              {loading ? 'Сохранение...' : 'Сменить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
